"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useSelectionCell = void 0;
const index_js_1 = require("../columns/index.js");
const useSelectionCell = (isSelectable, selectionMode, isRowDisabled, density = 'default') => (hooks) => {
    if (!isSelectable) {
        return;
    }
    hooks.allColumns.push((columns) => selectionMode === 'single' ||
        columns.find((c) => c.id === index_js_1.SELECTION_CELL_ID)
        ? columns
        : [
            (0, index_js_1.SelectionColumn)({ isDisabled: isRowDisabled, density: density }),
            ...columns,
        ]);
};
exports.useSelectionCell = useSelectionCell;
